<div class="card" [ngClass]="{
    'translucent-card': !ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid,
    'size-grid-mode': gridMode
  }">
    <div class="card-body">
        <div [ngClass]="{ 'flex-card-grid': gridMode, 'flex-card-list': !gridMode }">
            <div class="vehicle-img-container">
                <div class="next-img" (click)="nextImg($event)" *ngIf="hasMultipleImages">
                    <i class="fa-solid fa-chevron-circle-right"></i>
                </div>
                <div class="prev-img" (click)="prevImg($event)" *ngIf="hasMultipleImages">
                    <i class="fa-solid fa-chevron-circle-left"></i>
                </div>
                <a [routerLink]="[baseUrlDir, slug, vehicle.id]"
                    [ngClass]="{'no-img': !imgUrls || imgUrls.length <= 0}">
                    <app-fipe-comparison-badge
                      *ngIf="vehicle.fipeDiff !== undefined"
                      variant="overlay"
                      [fipeDiff]="vehicle.fipeDiff"
                      [displayMode]="FipeComparisonMode.DIFFERENCE"
                    />
                    <div class="has-video-container" *ngIf="vehicle.hasVideo">
                        <i class="fa-solid fa-video"></i>
                    </div>

                    <div class="new-car" *ngIf="vehicle.isNew && !ownsVehicle">Novidade</div>

                    <div class="tag-container showroom" *ngIf="vehicle.destination === 'SHOWROOM'"><i class="app-icon-showroom"></i>SHOWROOM</div>
                    <div class="card-gallery" *ngIf="imgUrls && imgUrls.length > 0">
                        <img class="rounded card-image" src="{{img}}" [ngClass]="{'show': imgIndex == i}"
                            *ngFor="let img of vehicleImages; let i = index" />
                    </div>
                    <div noImg class="no-img" *ngIf="!imgUrls || imgUrls.length <= 0">
                        <i class="material-icons">photo_library</i>
                    </div>
                </a>
            </div>
            <div class="vehicle-info">
                <a [routerLink]="[baseUrlDir, slug, vehicle.id]">
                    <div class="row">
                        <div class="col-10">
                            <div class="name">
                                {{ vehicle.make }} {{ vehicle.model }}
                            </div>
                        </div>
                        <div class="col-2">
                            <i class="fav-icon ml-2" (click)="toggleFavorite($event)" *ngIf="!ownsVehicle" [ngClass]="{
                            'app-icon-love': !vehicle.favorite, 'app-icon-love-alt': vehicle.favorite}">
                            </i>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-md-12">
                            <div class="years">
                                {{ vehicle.manufactureYear }}/{{ vehicle.modelYear }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="description">
                                {{ vehicle.trim }}
                            </div>
                        </div>
                    </div>
                </a>

            </div>

            <div class="row flex-grow-1 align-content-end">
                <div class="col-12">
                    <div class="infos">
                        <div class="row">
                            <div class="col-4 p-0 pl-4" style="max-width: 36.3%; flex: 36.3%">
                                <span>
                                    <i class="material-icons">maps</i>
                                    {{ vehicle.km | number }} km
                                </span>
                            </div>
                            <div class="col-4 p-0" style="max-width: 28.3%; flex: 28.3%">
                                <span *ngIf="vehicle.transmission !== undefined">
                                    <i class="material-icons">airline_seat_recline_normal</i>
                                    {{transmission}}
                                </span>
                            </div>
                            <div class="col-3 p-0 pl-1">
                                <span *ngIf="vehicle.fuel !== undefined">
                                    <i class="material-icons">local_gas_station</i>
                                    {{fuel}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex-grow-1 align-content-center mt-2">
                <div class="col-6 text-center" [ngClass]="{'mt-2': !vehicle.highestBid && !vehicle.hasBids}" *ngIf="vehicle.highestBid || vehicle.currentPrice">
                    <div class="row">
                        <div class="col-md-12 best-offer mb-1" *ngIf="vehicle.highestBid || (vehicle.hasBids)">
                            MAIOR OFERTA
                        </div>
                        <div class="col-12 best-offer-value">
                            <span class="money">R$</span> {{ (vehicle.currentPrice ? vehicle.currentPrice : vehicle.highestBid) | number: '1.0-0': 'pt-BR'}}
                        </div>
                    </div>
                </div>
                <div class="col-1" style="padding: 7px 0;" [ngClass]="{'countdown-margin' : !vehicle.highestBid && !vehicle.currentPrice}">
                    <div class="base-timer">
                        <svg class="base-timer__svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                            <g class="base-timer__circle">
                              <circle class="base-timer__path-elapsed" cx="60" cy="60" r="50"></circle>
                              <path class="base-timer__path-remaining" [attr.stroke-dasharray]="contador?.circleDasharray"
                                [ngClass]="{'green': !contador?.danger, 'red': contador?.danger}" d="
                                M 60, 60
                                m -50, 0
                                a 50,50 0 1,0 100,0
                                a 50,50 0 1,0 -100,0
                              "></path>
                            </g>
                          </svg>
                    </div>
                </div>
                <div class="col-5 timer-countdown">
                    <div>
                        <i class="material-icons">timer</i>
                        {{contador?.days}}d {{contador?.hours | number:'2.0-0'}}h {{contador?.minutes |
                        number:'2.0-0'}}m
                        {{contador?.seconds | number:'2.0-0'}}s
                    </div>
                </div>
            </div>
            <div class="row flex-grow-1 align-content-center mt-2 mb-2">
                <div class="col-3 ml-3">
                    <div class="img-oemDealer">
                        <img [src]="vehicle.oemDealerImgUrl">
                    </div>
                </div>
                <div class="col-8">
                    <div class="row">
                        <div class="col-12 oemDealer-name pt-1">
                            {{vehicle.oemDealerName}}
                        </div>
                        <div class="col-12 localization">
                           <span><i class="material-icons" style="color: #CBCED1">room</i> {{vehicle.city + ' / ' + vehicle.uf}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>